import React from "react";
import founderImg from "../assets/logo.jpeg";

const Founder = () => {
  return (
    <section id="founder" className="py-24 bg-white text-black">
      <div className="max-w-7xl mx-auto px-8">
        
        {/* Main Content */}
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-20">

          {/* Founder Image - Geometric Frame */}
          <div className="relative flex justify-center">
            {/* Outer white box with black border */}
            <div className="w-full max-w-md aspect-square border-4 border-black bg-white"></div>
            
            {/* Inner black frame */}
            <div className="absolute inset-0 flex items-center justify-center max-w-md mx-auto">
              <div className="w-5/6 h-5/6 border-4 border-black bg-black flex items-center justify-center">
                <img
                  src={founderImg}
                  alt="Founder"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          {/* Content */}
          <div>
            {/* Eyebrow */}
            <div className="mb-6 border-t border-b border-black py-4 inline-block">
              <span className="text-xs font-sans tracking-widest uppercase font-light">
                Founder & President
              </span>
            </div>

            {/* Name Heading */}
            <h2 className="text-5xl md:text-6xl font-black mt-6" style={{fontFamily: 'Georgia, serif'}}>
              Lion R.<br />
              Sam Rozer
            </h2>

            {/* Divider Line */}
            <div className="w-16 h-1 bg-black mt-8 mb-8"></div>

            {/* Description */}
            <p className="text-lg md:text-xl font-sans font-light text-gray-700 leading-relaxed">
              Legal Lions People Association was established with a vision to empower citizens through legal awareness, social welfare, and community service. Our mission is to ensure that legal knowledge reaches every individual and that people understand their rights, responsibilities, and opportunities within society.
            </p>

            <p className="text-lg md:text-xl font-sans font-light text-gray-700 leading-relaxed mt-6">
              We believe that awareness creates confidence, and confidence creates stronger communities. Through legal education programs, public service initiatives, and social welfare activities, we continue working towards a better and more informed society.
            </p>

            {/* Quote Section */}
            <div className="mt-10 border-l-4 border-black pl-6">
              <h4 className="font-black text-2xl" style={{fontFamily: 'Georgia, serif'}}>
                "Justice, Service & Leadership"
              </h4>

              <p className="text-sm font-sans tracking-widest uppercase mt-4">
                — Lion R. Sam Rozer
              </p>
            </div>
          </div>

        </div>

        {/* Divider */}
        <div className="h-px bg-black my-16"></div>

        {/* Statistics Grid - Clean Black and White */}
        <div className="grid md:grid-cols-4 gap-8">
          {/* Stat 1 */}
          <div className="border-2 border-black p-10 text-center hover:bg-black hover:text-white transition duration-300 group">
            <h3 className="text-5xl font-black group-hover:text-white mb-3">500+</h3>
            <p className="text-sm font-sans uppercase tracking-widest text-gray-600 group-hover:text-gray-300">
              Members
            </p>
          </div>

          {/* Stat 2 */}
          <div className="border-2 border-black p-10 text-center hover:bg-black hover:text-white transition duration-300 group">
            <h3 className="text-5xl font-black group-hover:text-white mb-3">100+</h3>
            <p className="text-sm font-sans uppercase tracking-widest text-gray-600 group-hover:text-gray-300">
              Legal Programs
            </p>
          </div>

          {/* Stat 3 */}
          <div className="border-2 border-black p-10 text-center hover:bg-black hover:text-white transition duration-300 group">
            <h3 className="text-5xl font-black group-hover:text-white mb-3">50+</h3>
            <p className="text-sm font-sans uppercase tracking-widest text-gray-600 group-hover:text-gray-300">
              Community Events
            </p>
          </div>

          {/* Stat 4 */}
          <div className="border-2 border-black p-10 text-center hover:bg-black hover:text-white transition duration-300 group">
            <h3 className="text-5xl font-black group-hover:text-white mb-3">10+</h3>
            <p className="text-sm font-sans uppercase tracking-widest text-gray-600 group-hover:text-gray-300">
              Years of Service
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Founder;